import { createDataTree } from '@progress/kendo-react-treelist';
import uid from './getUID';

export const createHierarchy = (data: any[], subItemsField, idField, parentIdField): any => {
  const hierarchy = createDataTree(
    data,
    (i) => i[idField],
    (i) => i[parentIdField],
    subItemsField
  );
  return hierarchy;
};

export const createPropItemsHierarchy = (data: any, subItemsField: string): any[] => {
  let mappedItems = data.map((item) => ({
    ...item,
    localId: item.id ? item.id : item.localId,
    parentLocalId: item.parentId ? item.parentId : item.parentLocalId,
  }));

  const hierarchy = createHierarchy(mappedItems, subItemsField, 'localId', 'parentLocalId');
  return hierarchy;
};

// Algorithm for generating unique localIds and localParentIds
export const createHierarchyWithUniqueValues = (data: any, subItemsField: string, idField, parentIdField): any[] => {
  data.forEach((e, i, a) => {
    let puid = uid();
    a.forEach((f) => f[parentIdField] === e[idField] && (f.localParentId = puid));
    e.localId = puid;
  });

  return createHierarchy(data, subItemsField, 'localId', 'localParentId');
};

export const filterParentFolderItems = (hierarchy, id) => {
  for (let i = 0; i < hierarchy.length; i++) {
    if (findNode(hierarchy[i], id)) {
      removeHierarchyNode(hierarchy, id);
      break;
    }
  }
};

const findNode = (node, id) => {
  if (node.id.toString() === id) {
    return node;
  }
  if (node.items) {
    for (let i = 0; i < node.items.length; i++) {
      return findNode(node.items[i], id);
    }
  }
};

//tree-view-helper
export const findNodeById = (nodes, id, field, childrenField) => {
  for (let i = 0; i < nodes.length; i++) {
    let node = nodes[i];
    if (node[field] === id) return node;

    if (node[childrenField]) {
      let descendent = findNodeById(node[childrenField], id, field, childrenField);
      if (descendent) return descendent;
    }
  }
};

const removeHierarchyNode = (hierarchy, id) => {
  for (let i = 0; i < hierarchy.length; i++) {
    if (removeNode(id, hierarchy[i], hierarchy, i)) break;
  }
};

const removeNode = (id, node, array, index) => {
  if (node.id.toString() === id) {
    array.splice(index, 1);
    return true;
  } else if (node.items) {
    for (let i = 0; i < node.items.length; i++) {
      return removeNode(id, node.items[i], node.items, i);
    }
  }
};

export const addPropertiesToHierarchicalData = (data, propertiesToUpdate, field) => {
  return data.map((item) => {
    for (const propName in propertiesToUpdate) {
      item[propName] = propertiesToUpdate[propName];
    }

    if (item[field] && item[field].length > 0) {
      item[field] = addPropertiesToHierarchicalData(item[field], propertiesToUpdate, field);
    }

    return item;
  });
};

export const updatePropertiesInHierarchyData = (data, itemId, propertiesToUpdate, field = 'items') => {
  return data.map((item) => {
    if (item.id === itemId) {
      for (const propName in propertiesToUpdate) {
        if (propertiesToUpdate.hasOwnProperty(propName)) {
          item[propName] = propertiesToUpdate[propName];
        }
      }
    }

    if (item[field] && item[field].length > 0) {
      item[field] = updatePropertiesInHierarchyData(item[field], itemId, propertiesToUpdate, field);
    }

    return item;
  });
};

export const updatePropertyForData = (gridData, propertyName, propertyValue) => {
  return gridData.map((item) => ({
    ...item,
    [propertyName]: propertyValue,
  }));
};

//TODO: Maybe to make single method for these two
export const updateSubitemsInGridData = (gridData, updatedItem) => {
  return gridData.map((item) => {
    if (item.id === updatedItem.id) {
      return updatedItem;
    } else if (item.subitems && item.subitems.length > 0) {
      return {
        ...item,
        subitems: updateSubitemsInGridData(item.subitems, updatedItem),
      };
    } else {
      return item;
    }
  });
};

//TODO: Maybe to make single method for these two
export const updateItemsInHierarchy = (data, updatedItem) => {
  return data.map((item) => {
    if (item.id === updatedItem.id) {
      return updatedItem;
    } else if (item.items && item.items.length > 0) {
      return {
        ...item,
        items: updateItemsInHierarchy(item.items, updatedItem),
      };
    } else {
      return item;
    }
  });
};

export const deleteItemById = (parent, itemId) => {
  parent.items = parent.items.filter((item) => {
    if (item.id === itemId) {
      return false;
    } else if (item.items && item.items.length > 0) {
      deleteItemById(item, itemId);
      return true;
    } else {
      return true;
    }
  });
};

export const renamePropertyInHierarchy = (data) => {
  return data.map((item) => {
    const updatedItem = { ...item };
    if (updatedItem.items) {
      updatedItem.nodes = renamePropertyInHierarchy(updatedItem.items);
      delete updatedItem.items;
    }
    return updatedItem;
  });
};
